import React from 'react';

const ShiftModal = ({
  isOpen,
  onClose,
  shiftType,
  班別清單,
  未分班清單,
  assignViaClick,
  handleRemoveFromShift,
}) => {
  const 班別代號 = shiftType.replace('班', '');

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 z-50 flex justify-center items-center overflow-auto">
      <div className="transition-all duration-300 transform bg-white rounded-lg p-4 w-[90%] max-w-4xl mx-auto mt-10 shadow-xl z-60 sm:w-[90%]">
        <h2 className="text-2xl font-bold text-center mb-4 text-purple-800">👥 人員分班</h2>

        <div className="grid grid-cols-2 gap-4">
          {/* 左側：未分班 */}
          <div>
            <h3 className="font-semibold text-center mb-2 text-gray-700">未分班人員</h3>
            <ul className="border border-teal-200 rounded p-2 min-h-[350px] max-h-[350px] overflow-auto bg-gray-50">
              {未分班清單.map((staff) => (
                <li
                  key={staff.id}
                  className="p-2 m-1 bg-white rounded shadow flex justify-between items-center"
                >
                  {staff.name}
                  <button
                    onClick={() => assignViaClick(staff, shiftType)}
                    className="px-2 py-1 text-sm bg-purple-500 text-white rounded hover:bg-purple-600"
                  >
                    加入
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* 右側：目前班別 */}
          <div>
            <h3 className="font-semibold text-center mb-2 text-gray-700">{shiftType}班</h3>
            <ul className="border border-teal-200 rounded p-2 min-h-[350px] max-h-[350px] overflow-auto bg-gray-50">
              {(班別清單[班別代號] || []).map((p) => (
                <li
                  key={p.id}
                  className="p-2 m-1 bg-white rounded shadow flex justify-between items-center"
                >
                  {p.name}
                  <button
                    onClick={() => handleRemoveFromShift(p)}
                    className="px-2 py-1 text-sm bg-red-500 text-white rounded hover:bg-red-600"
                  >
                    移除
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="text-center mt-6">
          <button
            onClick={onClose}
            className="px-6 py-2 bg-gray-400 text-white font-semibold rounded-full shadow hover:bg-gray-500"
          >
            關閉
          </button>
        </div>
      </div>
    </div>
  );
};

export default ShiftModal;
